import { calendlyUrl } from '@/content/site'

export function openCalendly() {
  const win = window as any
  if (win.Calendly) {
    win.Calendly.initPopupWidget({ url: calendlyUrl })
  } else {
    window.open(calendlyUrl, '_blank', 'noopener,noreferrer')
  }
}
